export type EnvServeMode = 'cloud' | 'on-promise' | 'on-premise';

function bool(value: string, defaultValue: boolean = false) {
  const str = String(value).trim().toLowerCase();
  if (str === '1' || str === 'true') {
    return true;
  }
  else if (str === '0' || str === 'false') {
    return false;
  }
  return defaultValue ?? false;
}

function num(value: any, defaultValue: number = -1) {
  const result = Number(value);
  if (Number.isNaN(result) || isNaN(result)) {
    return defaultValue;
  }
  return result;
}

function sanitize(value: string) {
  if (typeof value === 'string' && value?.trim() === 'null') {
    return null;
  }
  return value;
}

const serveMode = (import.meta.env.REACT_APP_MODE ?? 'cloud') as EnvServeMode;

export const envConfig = {
  serveMode,
  isCloud: serveMode === 'cloud' || serveMode == null,
  isOnPremise: ['on-promise', 'on-premise'].includes(serveMode),
  servicesURL: import.meta.env.REACT_APP_SERVICES_CONFIG_URL ?? null,
  guideLink: sanitize(import.meta.env.REACT_APP_GUIDE_LINK),

  locale: {
    default: sanitize(import.meta.env.REACT_APP_LOCALE) ?? 'fa'
  },

  ui: {
    onlySubsidy: bool(import.meta.env.REACT_APP_UI_ONLY_SUBSIDY, false),
    swiperShadow: bool(import.meta.env.REACT_APP_UI_SWIPER_SHADOW, false),
    removeCorpInfo: bool(import.meta.env.REACT_APP_UI_REMOVE_CORP_INFO, false),
    removeCurrency: bool(import.meta.env.REACT_APP_UI_REMOVE_CURRENCY, false),
    removeDormitoryPayment: bool(import.meta.env.REACT_APP_UI_REMOVE_DORMITORY_PAYMENT, false),
    removeWallet: bool(import.meta.env.REACT_APP_UI_REMOVE_WALLET, false),
    removeFAQ: bool(import.meta.env.REACT_APP_UI_REMOVE_FAQ, false),
    removeCVV2: bool(import.meta.env.REACT_APP_UI_REMOVE_CVV2, false),
    removeChangePassword: bool(import.meta.env.REACT_APP_UI_REMOVE_CHANGE_PASS, false),
    showLessReserveDetail: bool(import.meta.env.REACT_APP_UI_SHOW_LESS_RESERVE_DETAIL, false),

  },

  onPremise: {
    orgKey: sanitize(import.meta.env.REACT_APP_SAMAD_ORG_KEY) ?? 'samad-app',
    samadAPIUrl: import.meta.env.REACT_APP_SAMAD_API_URL,

    modules: {
      food: bool(import.meta.env.REACT_APP_MODULE_FOOD),
      sport: bool(import.meta.env.REACT_APP_MODULE_SPORT),
      health: bool(import.meta.env.REACT_APP_MODULE_HEALTH),
      transport: bool(import.meta.env.REACT_APP_MODULE_TRANSPORT),
      helpdesk: bool(import.meta.env.REACT_APP_MODULE_HELPDESK),
      dormitory: bool(import.meta.env.REACT_APP_MODULE_DORMITORY),
      survey: bool(import.meta.env.REACT_APP_MODULE_SURVEY),
      face: bool(import.meta.env.REACT_APP_MODULE_FACE)
    },

    core: {
      feedbackUrl: import.meta.env?.REACT_APP_CORE_FEEDBACK_URL,
      feedbackId: import.meta.env.REACT_APP_CORE_FEEDBACK_ID,
      teammateEnable: bool(import.meta.env.REACT_APP_TEAMMATE_ENABLE),
      activityReportEnable: bool(import.meta.env.REACT_APP_ACTIVITY_REPORT),
      showModalOnLogin: bool(import.meta.env.REACT_APP_CORE_SHOW_MODAL_ON_LOGIN),
      useNewAPI: bool(import.meta.env.REACT_APP_USE_NEW_RESERVE_API, false),
      auth: {
        casEnable: bool(import.meta.env.REACT_APP_AUTH_CAS_ENABLE),
        casForce: bool(import.meta.env.REACT_APP_AUTH_CAS_FORCE),
        casUrl: import.meta.env.REACT_APP_AUTH_CAS_URL,
        autoLogoutTime: num(import.meta.env.REACT_APP_AUTH_AUTO_LOGOUT_TIME, -1),
        captchaEnable: num(import.meta.env.REACT_APP_AUTH_SHOW_CAPTCHA, -1),
        casLogoutURL: import.meta.env.REACT_APP_AUTH_CAS_LOGOUT_URL ?? '',
        resetPassword: bool(import.meta.env.REACT_APP_AUTH_CAN_REST_PASSWORD, false),
      },
      changableReserveMode: bool(import.meta.env.REACT_APP_CHANGABLE_RESERVE_MODE, false),

    },

    helpdesk: {
      url: import.meta.env.REACT_APP_MODULE_HELPDESK_URL
    },

    face: {
      type: import.meta.env.REACT_APP_MODULE_FACE_TYPE,
      url: import.meta.env.REACT_APP_MODULE_FACE_URL
    },

  }

};

export default envConfig;
